// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ki-0";